import { PROVINCE_OK, PROVINCE_ERR } from "./province.action";

const InitState = {
  error: null,
  content: null,
};

export default function ProvinceReducer(state = InitState, action) {
  switch (action.type) {
    case PROVINCE_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case PROVINCE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
